module.exports = __webpack_public_path__ + "static/media/attention.7cce3c81.jpg";